module.exports = __webpack_public_path__ + "static/media/event-services-img32.75027e6a.jpg";